package com.loyola.acessoescola.ui.theme

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.myriad_pro_regular
import acessoescola.composeapp.generated.resources.source_serif_pro_Regular
import androidx.compose.material3.ExperimentalMaterial3ExpressiveApi
import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.text.font.FontFamily
import org.jetbrains.compose.resources.Font

val displayFontFamily: FontFamily @Composable get() = FontFamily(
    Font(
        resource = Res.font.source_serif_pro_Regular
    )
)

val bodyFontFamily: FontFamily @Composable get() = FontFamily(
    Font(
        resource = Res.font.myriad_pro_regular
    )
)
// Default Material 3 typography values
val baseline = Typography()

@OptIn(ExperimentalMaterial3ExpressiveApi::class)
val AppTypography: Typography @Composable get() {
    val appDisplayFont: FontFamily = displayFontFamily
    val appBodyFont: FontFamily = bodyFontFamily

    val appTypography = remember(appDisplayFont, appBodyFont) {
        Typography(
            displayLarge = baseline.displayLarge.copy(fontFamily = appDisplayFont),
            displayMedium = baseline.displayMedium.copy(fontFamily = appDisplayFont),
            displaySmall = baseline.displaySmall.copy(fontFamily = appDisplayFont),
            headlineLarge = baseline.headlineLarge.copy(fontFamily = appDisplayFont),
            headlineMedium = baseline.headlineMedium.copy(fontFamily = appDisplayFont),
            headlineSmall = baseline.headlineSmall.copy(fontFamily = appDisplayFont),
            titleLarge = baseline.titleLarge.copy(fontFamily = appDisplayFont),
            titleMedium = baseline.titleMedium.copy(fontFamily = appDisplayFont),
            titleSmall = baseline.titleSmall.copy(fontFamily = appDisplayFont),
            bodyLarge = baseline.bodyLarge.copy(fontFamily = appBodyFont),
            bodyMedium = baseline.bodyMedium.copy(fontFamily = appBodyFont),
            bodySmall = baseline.bodySmall.copy(fontFamily = appBodyFont),
            labelLarge = baseline.labelLarge.copy(fontFamily = appBodyFont),
            labelMedium = baseline.labelMedium.copy(fontFamily = appBodyFont),
            labelSmall = baseline.labelSmall.copy(fontFamily = appBodyFont)
        )
    }
    return appTypography
}